import { makeVar } from "@apollo/client";
import { MouseEvent } from "react";
import { DEFAULT_SPORT, IS_CLIENT, SPORTS_MAP, WebSportItem } from "src/constants";
import { getVariationId } from "./VariationService";

/**
 * Safely get the value of a query param to initialize reactive vars with the
 * correct value
 *
 * @param key query param key
 * @returns {string} the value of the query param
 */
function _getClientQueryParam(key: string) {
  let initialVal: string = "";
  if (IS_CLIENT) {
    const val = new URLSearchParams(window.location.search).get(key) ?? window.__NEXT_DATA__.query[key];
    if (val && typeof val === "string") {
      initialVal = val;
    }
  }
  return initialVal;
}

export const resolveHeadlessMode = (pathname: string, asPath: string, queryHeadless?: string | string[]): string => {
  if (pathname === "/subscribefunnel") {
    return "funnel";
  }

  const headless =
    typeof queryHeadless === "string"
      ? queryHeadless
      : new URLSearchParams(asPath.split("?")[1] ?? "").get("headless") ?? "";

  return headless === "0" ? "" : headless;
};

export const currentSport = makeVar<WebSportItem>(SPORTS_MAP[_getClientQueryParam("sport")] ?? DEFAULT_SPORT);
export const sportCountMismatch = makeVar<boolean>(false);
export const navBarPosition = makeVar<string | null>(null);
export const navBarLeague = makeVar<string | null>(null);
export const freeTrialDismissedVar = makeVar<boolean>(false);
export const promoDismissedVar = makeVar<boolean>(false);
export const gamesDashboardEvent = makeVar<MouseEvent | null>(null);
export const gamesModifyStatsEvent = makeVar<MouseEvent | null>(null);
export const customOfferModalOpen = makeVar<boolean>(false);
export const variationOverride = makeVar<number | null>(null);
export const variationId = makeVar<string>(getVariationId());
export const isHeadless = makeVar<string>(
  IS_CLIENT ? resolveHeadlessMode(window.location.pathname, window.location.href, _getClientQueryParam("headless")) : ""
);

export interface ApolloSettings {
  wss: string;
  http: string;
}

/**
 * Get the settings that bet is using for the apollo client
 * This returns the entire settings dictionary, so http or wss must be pulled out from it.
 */
const apolloBetSettings: () => ApolloSettings = () => {
  return {
    wss: process.env.NEXT_PUBLIC_GRAPHQL_WSS_URL ?? "ws://localhost:8000/graphql",
    http: process.env.NEXT_PUBLIC_GRAPHQL_HTTPS_URL ?? "http://localhost:8000/graphql",
  };
};

export default apolloBetSettings;
